<template>
    <div class="smart">
        <div class="fotoFull"> <!-- FOTO CARD HION TECNOLOGIA -->
                <img
                    src="../../assets/frontend_base_smart.jpg"
                    alt="HION TECNOLOGIA - SMART HOMES"
                    class="OpenCardBms"
                />
        </div> <!-- Final da DIV FOTO HION TECNOLOGIA -->

        <div class="contatoHome">
            <div class="backgroundContatoHome">
                <mq-layout mq="md+">
                    <div class="efeitoLogoContatoHome1">
                        <HionEffect class="HionEffectHomeContato1" :configHionEffect="configHionEffectHomeContato" />
                    </div>
                    <div class="efeitoLogoContatoHome2">                 
                        <HionEffect class="HionEffectHomeContato2" :configHionEffect="configHionEffectHomeContato" />
                    </div>
                    <LinhaHorizontal :configLinhas="configLinhasContato" class="efeitoLinhaContatoHome" />
                </mq-layout>
                <mq-layout :mq="['xs', 'sm']">
                    <div class="efeitoLogoContatoHomeSmall">
                        <HionEffect class="HionEffectHomeContatoSmall" :configHionEffect="configHionEffectHomeContatoSmall" />
                    </div>
                </mq-layout>
            </div>
            <div class="frontendContatotHome">
                <router-link to="/Contatos">
                    <div class="tituloContatoHome">Possui projetos nesta área e necessita armazenar energia?<br>Fale com a gente!</div>
                </router-link>
                <div class="formContatoHome">
                    <b-form @submit="SubmitFormContatoHome">
                        <b-form-group id="FormGrupoEmail">
                            <b-form-input
                            id="input-Email-Contato"
                            v-model="form.email"
                            type="email"
                            required
                            placeholder="seuemail@gmail.com"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group id="FormGrupoMensagem">
                            <b-form-input
                            id="input-Mensagem-Contato"
                            v-model="form.mensagem"
                            required
                            placeholder="Mensagem"
                            ></b-form-input>
                        </b-form-group>

                        <b-button type="submit" class="botaoFormContato">Enviar</b-button>
                    </b-form>
                </div>
            </div>
        </div>

        <div class="newsletterHome">
            <b-container fluid class="containerNewsletter">
                <b-row align-v="center" class="rowNewsletter">
                    <b-col cols="12" md="6" align-self="center" class="text-center textoNewsletterHome">
                        Fique por dentro de nossas novidades. Inscreva-se
                    </b-col>
                    <b-col cols="12" md="6" align-self="center" class="text-center inputNewsletterHome">
                        <b-form @submit="SubmitFormNewsletterHome">
                            <b-form-group id="FormGrupoNewsletter">
                                <b-form-input
                                id="input-Email-Newsletter"
                                v-model="newsletter.email"
                                type="email"
                                required
                                placeholder="seuemail@gmail.com"
                                v-on:keyup.enter="submit"
                                ></b-form-input>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
            </b-container>
        </div>

    </div>
</template>

<script>
import LinhaHorizontal from '../efeitos/LinhaHorizontal'
import HionEffect from '../efeitos/hion_globo'

export default {
    name: 'Smart',
    components: { LinhaHorizontal, HionEffect },
    data() {
        return {
            form: {
                    email: '',
                    mensagem: ''
                },
                newsletter: {
                    email: ''
                },
            configHionEffectHomeContato: {
                backgroundHionEffect: "#fff",
                CorHionEffect:"#008fac",
            },
            configHionEffectHomeContatoSmall: {
                backgroundHionEffect: "#000",
                CorHionEffect:"#008fac",
            },
            configLinhasContato: {
                backgroundLinhas: "#fff",
                CorLinhas: "#008fac"
            }
        }
    },
    methods: {
        SubmitFormContatoHome(evt) {
            evt.preventDefault()
            alert(JSON.stringify(this.form))
        },
        SubmitFormNewsletterHome(evt) {
            evt.preventDefault()
            alert('Cadastro Realizado com Sucesso - '+ JSON.stringify(this.newsletter))
        },
    }
}
</script>

<style>
.smart {
    position: relative;
    background:#fff;
    color: #2e2d2c;
    height: 100%;
    width: 100%;
    min-height: 500px;
}
</style>